// Translation dictionaries for Vietnamese and English
import type { Translations, Language } from '../types/language';

export const translations: Record<Language, Translations> = {
  vi: {
    common: {
      loading: 'Đang tải...',
      cancel: 'Hủy',
      confirm: 'Xác nhận',
      save: 'Lưu',
      edit: 'Chỉnh sửa',
      delete: 'Xóa',
      error: 'Lỗi',
      retry: 'Thử lại',
      continue: 'Tiếp tục',
      back: 'Quay lại',
      unknown: 'Không xác định'
    },
    welcome: {
      title: 'Chào mừng đến với Kiosk Chat',
      subtitle: 'Hệ thống chat thông minh cho kiosk',
      description: 'Đây là hệ thống kiosk thông minh giúp bạn tìm hiểu về các thủ tục hành chính Việt Nam. Vui lòng thiết lập thiết bị để bắt đầu sử dụng.',
      getStarted: 'Bắt đầu thiết lập'
    },

    deviceSetup: {
      title: 'Thiết lập thiết bị',
      deviceNameLabel: 'Tên thiết bị',
      deviceNamePlaceholder: 'Nhập tên thiết bị',
      apiKeyLabel: 'API Key',
      apiKeyPlaceholder: 'Nhập API key',
      registerButton: 'Đăng ký thiết bị',
      registering: 'Đang đăng ký...',
      success: 'Đăng ký thành công',
      errors: {
        deviceNameRequired: 'Tên thiết bị là bắt buộc',
        deviceNameTooShort: 'Tên thiết bị quá ngắn',
        deviceNameTooLong: 'Tên thiết bị quá dài',
        apiKeyRequired: 'API key là bắt buộc',
        apiKeyInvalid: 'API key không hợp lệ',
        registrationFailed: 'Đăng ký thất bại',
        networkError: 'Lỗi kết nối mạng'
      }
    },

    language: {
      label: 'Ngôn ngữ',
      vietnamese: 'Tiếng Việt',
      english: 'English'
    },
      settings: {
        title: 'Cài đặt thiết bị',
        tts: {
          title: 'Giọng đọc (Text-to-Speech)',
          description: 'Chọn giọng đọc và cài đặt đọc tự động',
          currentVoice: 'Giọng đọc hiện tại',
          autoSpeak: {
            title: 'Đọc tự động',
            description: 'Tự động đọc trả lời của AI'
          }
        },
        device: {
        title: 'Thông tin thiết bị',
        description: 'Quản lý thông tin thiết bị',
        name: 'Tên thiết bị',
        status: 'Trạng thái',
        active: 'Hoạt động',
        inactive: 'Không hoạt động',
        registered: 'Đã đăng ký',
        lastActive: 'Hoạt động lần cuối',
        rename: 'Đổi tên',
        renameTitle: 'Đổi tên thiết bị',
        renameDescription: 'Nhập tên mới cho thiết bị',
        renameConfirm: 'Xác nhận đổi tên'
      },
      session: {
        title: 'Phiên làm việc',
        description: 'Thông tin phiên làm việc hiện tại',
        id: 'ID phiên',
        started: 'Bắt đầu',
        timeRemaining: 'Thời gian còn lại',
        lastAccessed: 'Truy cập lần cuối',
        expired: 'Đã hết hạn',
        refresh: 'Làm mới'
      },
      language: {
        title: 'Cài đặt ngôn ngữ',
        description: 'Chọn ngôn ngữ hiển thị',
        current: 'Ngôn ngữ hiện tại'
      },
      system: {
        title: 'Thông tin hệ thống',
        description: 'Thông tin về ứng dụng và kết nối',
        version: 'Phiên bản ứng dụng',
        apiStatus: 'Trạng thái API',
        connected: 'Đã kết nối',
        disconnected: 'Mất kết nối'
      },
      danger: {
        title: 'Vùng nguy hiểm',
        description: 'Các hành động không thể hoàn tác'
      },
      signOut: {
        button: 'Đăng xuất',
        confirmTitle: 'Xác nhận đăng xuất',
        confirmDescription: 'Bạn có chắc chắn muốn đăng xuất?',
        confirm: 'Đăng xuất'
      }
    },
    chat: {
      confidence: {
        high: 'Độ tin cậy cao',
        medium: 'Độ tin cậy trung bình',
        low: 'Độ tin cậy thấp',
        label: 'Độ tin cậy',
        highDescription: 'Thông tin rất đáng tin cậy',
        mediumDescription: 'Thông tin có độ tin cậy trung bình',
        lowDescription: 'Vui lòng kiểm tra thêm thông tin'
      },
      sources: {
        title: 'Nguồn tham khảo',
        showSources: 'Hiển thị nguồn',
        hideSources: 'Ẩn nguồn',
        openSource: 'Mở nguồn',
        noSources: 'Không có nguồn tham khảo'
      },
      copy: {
        button: 'Sao chép',
        copied: 'Đã sao chép',
        copyMessage: 'Sao chép tin nhắn',
        copyFailed: 'Không thể sao chép'
      },
      message: {
        you: 'Bạn',
        assistant: 'Trợ lý AI',
        timestamp: 'Thời gian'
      },
      api: {
        errors: {
          networkError: 'Lỗi kết nối mạng. Vui lòng kiểm tra kết nối internet.',
          timeout: 'Yêu cầu quá thời gian. Vui lòng thử lại.',
          authenticationFailed: 'Xác thực thất bại. Vui lòng đăng nhập lại.',
          tooManyRequests: 'Quá nhiều yêu cầu. Vui lòng thử lại sau.',
          invalidResponse: 'Phản hồi không hợp lệ từ máy chủ.',
          questionEmpty: 'Câu hỏi không được để trống.',
          questionTooLong: 'Câu hỏi quá dài. Tối đa 1000 ký tự.',
          serviceUnavailable: 'Dịch vụ tạm thời không khả dụng.',
          unexpectedError: 'Đã xảy ra lỗi không mong muốn.',
          retryFailed: 'Thử lại thất bại. Vui lòng kiểm tra kết nối.'
        },
        loading: {
          processing: 'Đang xử lý câu hỏi...',
          searching: 'Đang tìm kiếm thông tin...',
          analyzing: 'Đang phân tích...'
        }
      }
    }
  },
  en: {
    common: {
      loading: 'Loading...',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      error: 'Error',
      retry: 'Retry',
      continue: 'Continue',
      back: 'Back',
      unknown: 'Unknown'
    },
    welcome: {
      title: 'Welcome to Kiosk Chat',
      subtitle: 'Smart chat system for kiosks',
      description: 'This is an intelligent kiosk system to help you learn about Vietnamese administrative procedures. Please set up your device to get started.',
      getStarted: 'Get Started'
    },

    deviceSetup: {
      title: 'Device Setup',
      deviceNameLabel: 'Device Name',
      deviceNamePlaceholder: 'Enter device name',
      apiKeyLabel: 'API Key',
      apiKeyPlaceholder: 'Enter API key',
      registerButton: 'Register Device',
      registering: 'Registering...',
      success: 'Registration successful',
      errors: {
        deviceNameRequired: 'Device name is required',
        deviceNameTooShort: 'Device name is too short',
        deviceNameTooLong: 'Device name is too long',
        apiKeyRequired: 'API key is required',
        apiKeyInvalid: 'API key is invalid',
        registrationFailed: 'Registration failed',
        networkError: 'Network error'
      }
    },

    language: {
      label: 'Language',
      vietnamese: 'Tiếng Việt',
      english: 'English'
    },
      settings: {
        title: 'Device Settings',
        tts: {
          title: 'Text-to-Speech',
          description: 'Choose voice and auto speak settings',
          currentVoice: 'Current voice',
          autoSpeak: {
            title: 'Auto speak',
            description: 'Automatically speak AI responses'
          }
        },
        device: {
        title: 'Device Information',
        description: 'Manage device information',
        name: 'Device Name',
        status: 'Status',
        active: 'Active',
        inactive: 'Inactive',
        registered: 'Registered',
        lastActive: 'Last Active',
        rename: 'Rename',
        renameTitle: 'Rename Device',
        renameDescription: 'Enter new device name',
        renameConfirm: 'Confirm Rename'
      },
      session: {
        title: 'Session',
        description: 'Current session information',
        id: 'Session ID',
        started: 'Started',
        timeRemaining: 'Time Remaining',
        lastAccessed: 'Last Accessed',
        expired: 'Expired',
        refresh: 'Refresh'
      },
      language: {
        title: 'Language Settings',
        description: 'Choose display language',
        current: 'Current Language'
      },
      system: {
        title: 'System Information',
        description: 'Application and connection information',
        version: 'App Version',
        apiStatus: 'API Status',
        connected: 'Connected',
        disconnected: 'Disconnected'
      },
      danger: {
        title: 'Danger Zone',
        description: 'Irreversible actions'
      },
      signOut: {
        button: 'Sign Out',
        confirmTitle: 'Confirm Sign Out',
        confirmDescription: 'Are you sure you want to sign out?',
        confirm: 'Sign Out'
      }
    },
    chat: {
      confidence: {
        high: 'High confidence',
        medium: 'Medium confidence',
        low: 'Low confidence',
        label: 'Confidence',
        highDescription: 'Very reliable information',
        mediumDescription: 'Moderately reliable information',
        lowDescription: 'Please verify additional information'
      },
      sources: {
        title: 'Sources',
        showSources: 'Show sources',
        hideSources: 'Hide sources',
        openSource: 'Open source',
        noSources: 'No sources available'
      },
      copy: {
        button: 'Copy',
        copied: 'Copied',
        copyMessage: 'Copy message',
        copyFailed: 'Failed to copy'
      },
      message: {
        you: 'You',
        assistant: 'AI Assistant',
        timestamp: 'Timestamp'
      },
      api: {
        errors: {
          networkError: 'Network error. Please check your internet connection.',
          timeout: 'Request timeout. Please try again.',
          authenticationFailed: 'Authentication failed. Please log in again.',
          tooManyRequests: 'Too many requests. Please try again later.',
          invalidResponse: 'Invalid response from server.',
          questionEmpty: 'Question cannot be empty.',
          questionTooLong: 'Question is too long. Maximum 1000 characters allowed.',
          serviceUnavailable: 'Service temporarily unavailable.',
          unexpectedError: 'An unexpected error occurred.',
          retryFailed: 'Retry failed. Please check your connection.'
        },
        loading: {
          processing: 'Processing question...',
          searching: 'Searching for information...',
          analyzing: 'Analyzing...'
        }
      }
    }
  }
};

export const getTranslation = (language: Language, key: string): string => {
  const keys = key.split('.');
  let value: unknown = translations[language];
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = (value as Record<string, unknown>)[k];
    } else {
      return key;
    }
  }
  
  return typeof value === 'string' ? value : key;
};